<template>
  <div class="appmenu">
    <div class="mainmenu">
      <router-link :to="{ name: 'list' }" @click.native="submenu('list')"
        ><font-awesome-icon :icon="['fas', 'hand-pointer']" /><span
          class="title"
          >Select project</span
        ></router-link
      >
      <div>
        <router-link
          :to="{ name: 'summary' }"
          @click.native="submenu('summary')"
          ><font-awesome-icon :icon="['fas', 'eye']" /><span class="title"
            >Summary project</span
          ></router-link
        >
        <router-link
          :to="{ name: 'settings' }"
          @click.native="submenu('settings')"
          ><font-awesome-icon :icon="['fas', 'cogs']" /><span class="title"
            >Settings</span
          ></router-link
        >
        <router-link
          :to="{ name: 'correct' }"
          @click.native="submenu('correct')"
          ><font-awesome-icon :icon="['fas', 'check']" /><span class="title"
            >Correct</span
          ></router-link
        >
        <router-link
          :to="{ name: 'results_export' }"
          @click.native="submenu('results_export')"
          ><font-awesome-icon :icon="['fas', 'file-export']" /><span
            class="title"
            >Export results</span
          ></router-link
        >
        <router-link :to="{ name: 'exit' }" @click.native="submenu('exit')"
          ><font-awesome-icon :icon="['fas', 'sign-out-alt']" /><span
            class="title"
            >Exit</span
          ></router-link
        > __04-02-2020 10:00
      </div>
    </div>
    <div class="submenu" v-show="menu_selectie == 'list'">
      <font-awesome-icon :icon="['fas', 'hand-pointer']" /><br /><br />
    </div>
    <div class="submenu" v-show="menu_selectie == 'summary'">
      <font-awesome-icon :icon="['fas', 'eye']" /><br /><br />
    </div>
    <div class="submenu" v-show="menu_selectie == 'settings'">
      <font-awesome-icon :icon="['fas', 'cogs']" /><br /><br />
      <router-link :to="{ name: 'settings_filter' }"
        ><font-awesome-icon :icon="['fas', 'filter']" /><span class="title"
          >Object filter</span
        ></router-link
      >
      <router-link :to="{ name: 'settings_zones' }"
        ><font-awesome-icon :icon="['fas', 'vector-square']" /><span
          class="title"
          >Movement zones</span
        ></router-link
      >
      <router-link :to="{ name: 'settings_loose_ends' }"
        ><font-awesome-icon :icon="['fas', 'code-branch']" /><span class="title"
          >Loose ends</span
        ></router-link
      >
      <router-link :to="{ name: 'settings_routing' }"
        ><font-awesome-icon :icon="['fas', 'route']" /><span class="title"
          >Routing</span
        ></router-link
      >
      <router-link :to="{ name: 'settings_class' }"
        ><font-awesome-icon :icon="['fas', 'stamp']" /><span class="title"
          >Classification</span
        ></router-link
      >
      <router-link :to="{ name: 'settings_class_manual' }"
        ><font-awesome-icon :icon="['fas', 'hand-holding']" />
        <span class="title">Manual classification</span>
      </router-link>
      <router-link :to="{ name: 'settings_directions' }"
        ><font-awesome-icon :icon="['fas', 'compress']" /><span class="title"
          >Directions</span
        ></router-link
      >
    </div>
    <div class="submenu" v-show="menu_selectie == 'correct'">
      <font-awesome-icon :icon="['fas', 'check']" /><br /><br />
      <router-link :to="{ name: 'correct_loose_ends' }"
        ><font-awesome-icon :icon="['fas', 'code-branch']" /><span class="title"
          >Loose ends</span
        ></router-link
      >
      <router-link :to="{ name: 'correct_routing' }"
        ><font-awesome-icon :icon="['fas', 'route']" /><span class="title"
          >Routing</span
        ></router-link
      >
      <router-link :to="{ name: 'correct_class' }"
        ><font-awesome-icon :icon="['fas', 'stamp']" /><span class="title"
          >Classification</span
        ></router-link
      >
    </div>
    <div class="submenu" v-show="menu_selectie == 'results'">
      <font-awesome-icon :icon="['fas', 'chart-bar']" /><br /><br />
    </div>
    <div class="submenu" v-show="menu_selectie == 'results_export'">
      <font-awesome-icon :icon="['fas', 'file-export']" /><br /><br />
    </div>
    <div class="submenu" v-show="menu_selectie == 'exit'">
      <a href="https://trafficdistillery.com"
        ><font-awesome-icon :icon="['fas', 'sign-out-alt']"
      /></a>
    </div>
  </div>

</template>
<script>
/*
        <router-link
          :to="{ name: 'results' }"
          @click.native="submenu('results')"
          ><font-awesome-icon :icon="['fas', 'chart-bar']" /><span class="title"
            >Results</span
          ></router-link
        >

*/
export default {
  methods: {
    submenu(tvar) {
      this.menu_selectie = tvar;
    }
  },
  data: function() {
    return {
      menu_selectie: "0"
    };
  }
};
</script>

<style scoped>
.appmenu svg {
  margin-left: 10px;

  color: #42b983 !important;
  font-size: 150% !important;
  width: 34px !important;
}

.appmenu .title {
  margin: 15px;
  vertical-align: top;
}
.appmenu a {
  color: green;
  text-decoration: none;
  line-height: 30px;
  font-size: 0.8em;
  float: left;
  clear: both;
  width: 100%;
}
.appmenu a:hover {
  /* background-color: #42b98340; */
  background-color: lightgreen;
}
.appmenu .router-link-active {
  /* background-color: #42b98340; */
  background-color: lightgreen;
}

.mainmenu {
  height: 350px;
  box-sizing: border-box;
  border-width: thin;
  border-style: solid;
  border-color: black;
}

.submenu {
  box-sizing: border-box;
  margin-top: 5px;
  padding-top: 5px;
  height: 350px;
  border-width: thin;
  border-style: solid;
  border-color: black;
}
</style>
